import { createFileRoute } from '@tanstack/react-router'
import { AuditTrail } from '../components/AuditTrail.js'

export const Route = createFileRoute('/_app/super/audit-trail/')({
  component: SuperAuditTrailPage,
})

function SuperAuditTrailPage() {
  return (
    <AuditTrail
      endpoint="/api/v1/super/audit-logs"
      queryKey={['super', 'audit-logs']}
      title="Activity"
      description="Platform-wide activity across all academies, including platform-level actions."
      showAcademy
    />
  )
}
